import { WalletGroup } from "@ts-types/generated";
import React, { useMemo } from "react";
export interface State {
  siteTitle: string;
  siteSubtitle: string;
  currency: string;
  logo: any;
  category: {
    category_size: number;
  };
  wallets_info: Array<WalletGroup>;
  cart_info?: {
    amount: number
  };
  dob_min_year?: number;
}

const initialState = {
  siteTitle: "Accordia Website Management Dashboard",
  siteSubtitle: "",
  currency: "MYR",
  logo: {
    id: 1,
    thumbnail: "/logo.png",
    original: "/logo.png",
  },
  category: {
    category_size: 280
  },
  wallets_info: [],
  dob_min_year: 12,
};

export const SettingsContext = React.createContext<State | any>(initialState);

SettingsContext.displayName = "SettingsContext";

export const SettingsProvider: React.FC<{ initialValue: any }> = ({
  initialValue,
  ...props
}) => {
  const [state, updateSettings] = React.useState(initialValue ?? initialState);
  const value = useMemo(
    () => ({
      ...state,
      updateSettings,
    }),
    [state]
  );
  return <SettingsContext.Provider value={value} {...props} />;
};

export const useSettings = () => {
  const context = React.useContext<State>(SettingsContext);
  if (context === undefined) {
    throw new Error(`useSettings must be used within a SettingsProvider`);
  }
  return context;
};
